import { useEffect, useState } from "react";
import suggestIndustryCategory from "../../../apis/suggestIndustryCategory";
import {
  getCachedIndustryCategorySuggestion,
  saveCachedIndustryCategorySuggestion,
} from "../../../utils/industryCategorySuggestionCache";

export function useIndustryCategorySuggestion({ userId, name, description, setFormData }) {
  const [suggesting, setSuggesting] = useState(false);

  useEffect(() => {
    const trimmedName = String(name ?? "").trim();
    const trimmedDescription = String(description ?? "").trim();

    if (!userId || !trimmedName || !trimmedDescription) {
      setSuggesting(false);
      return undefined;
    }

    if (getCachedIndustryCategorySuggestion(userId, trimmedName, trimmedDescription)) {
      setSuggesting(false);
      return undefined;
    }

    let cancelled = false;
    setSuggesting(true);

    suggestIndustryCategory({ name: trimmedName, description: trimmedDescription })
      .then((result) => {
        if (cancelled) return;

        saveCachedIndustryCategorySuggestion(userId, {
          name: trimmedName,
          description: trimmedDescription,
          industry: result?.industry ?? null,
          category: result?.category ?? null,
          found: Boolean(result?.found),
        });

        if (result?.found && result.industry && result.category) {
          setFormData((prev) => ({
            ...prev,
            industry: result.industry,
            category: result.category,
          }));
        }
      })
      .catch((err) => {
        if (!cancelled) {
          console.error("Industry category suggestion failed:", err);
        }
      })
      .finally(() => {
        if (!cancelled) {
          setSuggesting(false);
        }
      });

    return () => {
      cancelled = true;
    };
  }, [userId, name, description, setFormData]);

  return { suggesting };
}
